import type { QueryKey } from "@tanstack/react-query";

import type { MethodName, Tag } from "../apiClient";
import type { Args } from "../queryTypes";

export function getQueryKey<T extends Tag>(params: { tag: T }): QueryKey;
export function getQueryKey<T extends Tag, M extends MethodName<T>>(params: {
    tag: T;
    methodName: M;
    args?: Args<T, M>;
}): QueryKey;

export function getQueryKey<T extends Tag, M extends MethodName<T>>({
    tag,
    methodName,
    args,
}: {
    tag: T;
    methodName?: M;
    args?: Args<T, M>;
}): QueryKey {
    return methodName ? [tag, methodName, ...(args || [])] : [tag];
}
